
import { defineComponent } from 'vue'
import ADropdown from '@/components/ADropdown.vue'
import ADropdownTires from '@/components/ADropdownTires.vue'
import { bodyWork,
  airConditioner,
  heater,
  exhaust,
  transmission,
  engine,
  steering,
  chassis,
  electrical,
  maintenance,
  brakeSystem } from '@/assets/data/prices'

export default defineComponent({
  components: { ADropdown, ADropdownTires },
  setup() {
    return { 
      bodyWork,
      airConditioner,
      heater,
      exhaust,
      transmission,
      engine,
      steering,
      chassis,
      electrical,
      maintenance,
      brakeSystem
    }
  }
})
